export default {"src":"/_next/static/media/ix_certificate-success.b75de02c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};